import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/ui/Loading";
import { fetchJobs } from "../../features/jobs/jobsSlice";
import SingleJob from "../SingleJob/SingleJob";

function Joblist() {
  const dispatch = useDispatch();
  const { jobs, isLoading, isError, error, jobsCategory, search } = useSelector(
    (state) => state.jobs
  );
  // const status = useSelector((state) => state.filter);
  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch]);
  // decide what to render
  let content;

  if (isLoading) content = <Loading />;
  if (!isLoading && isError) content = <div>{error}</div>;
  // content = <div className="col-span-12">{error}</div>;

  if (!isError && !isLoading && jobs?.length === 0) {
    content = <div>No blogs found!</div>;
  }

  // console.log(filterStatus.fliterStatus);
  if (!isError && !isLoading && jobs?.length > 0) {
    if (jobsCategory === "all")
      content = jobs.map((job) => {
        if (job.title.toLowerCase().includes(search.toLowerCase()))
          return <SingleJob key={job.id} job={job} />;
        else return "";
      });
      if (jobsCategory === "internship")
      content = jobs.map((job) => {
        if (
          job.type==="Internship" &&
          job.title.toLowerCase().includes(search.toLowerCase())
        )
          return <SingleJob key={job.id} job={job} />;
        return "";
      });
      if (jobsCategory === "fullTime")
      content = jobs.map((job) => {
        if (
          job.type==="Full Time" &&
          job.title.toLowerCase().includes(search.toLowerCase())
        )
          return <SingleJob key={job.id} job={job} />;
        return "";
      });
      if (jobsCategory === "remote")
      content = jobs.map((job) => {
        if (
          job.type==="Remote" &&
          job.title.toLowerCase().includes(search.toLowerCase())
        )
          return <SingleJob key={job.id} job={job} />;
        return "";
      });
  }

  return (
    <div className="jobs-list">
      {/* <SingleJob /> */}
      {content}
    </div>
  );
}

export default Joblist;
